import React from 'react';
import bgImage from '../../assets/Testimonials.webp';

const Breadcrumb = () => {
  return (
    <div className='hero'>
      <img
        src={bgImage}
        alt='breadcrumb background'
        className='hero-img'
      />
      {/* <ul className='breadcumb'>
        <li>Home</li>
        <li>Testimonials</li>
      </ul> */}
    </div>
  );
};

export default Breadcrumb;
